module.exports = __webpack_public_path__ + "static/media/PM116.84975ad7.png";